// Merge fields in email templates: `{{code}}`, `{{firstName}}` and so on.
// Used by the admin template editor to render a preview with real values in place.
const PLACEHOLDER = /\{\{\s*([\w.-]+)\s*\}\}/g;
/**
 * The tokens present in a template, in first-seen order and without duplicates, so a
 * caller can build one field per placeholder from the template itself.
 */
export function findPlaceholders(body) {
    const seen = [];
    for (const match of (body || '').matchAll(PLACEHOLDER)) {
        if (!seen.includes(match[1]))
            seen.push(match[1]);
    }
    return seen;
}
function escapeHtml(value) {
    return value
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}
/**
 * Substitutes values into a template. Values are escaped, since they land in markup.
 * A token with no value is left as it is, so it stays visible in a preview rather than
 * turning into a confusing blank.
 */
export function applyPlaceholders(body, values) {
    return (body || '').replace(PLACEHOLDER, (whole, key) => {
        const value = values ? values[key] : '';
        return value ? escapeHtml(value) : whole;
    });
}
